module.exports = __webpack_public_path__ + "img/bottom-btn-active.dc43a183.png";